import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  FP_OTP_ERROR,
  PASSWORD_CHANGE_BY,
  SET_PASSWORD_OTP_REQUEST_ID,
  SET_PASSWORD_TOKEN,
  SHOW_OTP,
} from './types';

const changeBy = createReducer(null, {
  [PASSWORD_CHANGE_BY]: (draft, { payload }) => payload.changeBy,
});

const otpError = createReducer(null, {
  [FP_OTP_ERROR]: (draft, { payload }) => payload.otpError,
});

// FIXME wrong default type
const requestId = createReducer(null, {
  [SET_PASSWORD_OTP_REQUEST_ID]: (draft, { payload }) => payload.request_id,
});

const showOtp = createReducer(false, {
  [SHOW_OTP]: (draft, { payload }) => payload,
});

// FIXME wrong default type
const token = createReducer(null, {
  [SET_PASSWORD_TOKEN]: (draft, { payload }) => payload.token,
});

export default combineReducers({
  changeBy,
  otpError,
  // FIXME camelcase
  request_id: requestId,
  showOtp,
  token,
});
